import type { FaireProductEntity } from "../../entity_types/product";

export const p_wmjp7d9nkb: FaireProductEntity = {
  token: "p_wmjp7d9nkb",
  type: "product",
  name: "OPTIMIZE MINERALS AND VITAMINZ BUNDLE™️",
  brandToken: "b_vjrx63e348",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/894da683c9ac9760f62232cc716935c940bca767e63d9ef8907089b3fbf2559b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/993d2ff90f91b457f44749842a73350ab05ed813d6224543e0b9d1bc289846f2.png",
    "https://cdn.faire.com/fastly/3bd5d68224f88935626b4c0ea30b358cd2923a079dc88aa536bf1dfe07068d52.png",
    "https://cdn.faire.com/fastly/66d1aee4c7d0bf1b35db4b84f11e511de76561ab1f344cf963a3f1901e5f7455.png",
    "https://cdn.faire.com/fastly/cd15556e27ea740f5f12a6bbb79dfffdd353edccbeae131869da4daaf58061d8.png",
  ],
  priceDollars: 76,
  description:
    "\nBUNDLE AND SAVE!! \n\nBy bundling, you are getting 20% OFF of minerals, and 36% OFF of Vitaminz!\n\nOptimize Minerals & Vitaminz Bundle is not eligible for discount codes due to them already being heavily discounted! \n\nOptimize Vitamins is another first of its kind containing all whole food, fat soluble vitamins A,E,D3, K2 menna 7, paired with functional herbs, antioxidants and essential trace minerals we can not get from our diets. \n\nWelcome to your new flexible and absorption focused supplement routine with OM and OV combined. \nThis is designed to be paired with Optimize Minerals for your convenience. \n\nWe separated these vitamins so you can have flexibility with your routine by being able to combine this with OM on days you have already eaten.",
  tags: [],
  msrpDollars: 152,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:49.215Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
